module.exports = __webpack_public_path__ + "static/img/gzh.074e08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzh.png
// module id = rBkr
// module chunks = 1